

export enum Direction {
    ltr = 'ltr',
    rtl = 'rtl'
}
